import { useContext } from 'react'

import { ConfigContext, ConfigContextProps } from '@/contexts/config'

interface UseConfigProps {
  config: ConfigContextProps['config']
  updateConfig: (config: ConfigContextProps['config']) => void
}

export const useConfig = (): UseConfigProps => {
  const { config, setConfig } = useContext(ConfigContext)

  const updateConfig = (config: ConfigContextProps['config']) => {
    setConfig(config)
  }

  return {
    config,
    updateConfig
  }
}
